/**
 * GetToken
 * provide link and ask user to provide token from Trello
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormGroup, HelpBlock, ControlLabel, FormControl, Button } from 'react-bootstrap';
import { AUTH_URL, TRELLO_KEY } from '../config';
import serialize from '../utils/serialize';

const Wrapper = styled.div`
  input {
    font-family: monospace;
    width: 60rem;
  }
`;

class GetToken extends React.PureComponent {
  state = { value: '' };
  handleChange = this.handleChange.bind(this)
  handleChange(ev) {
    this.setState({ value: ev.target.value });
  }

  handleSubmit = this.handleSubmit.bind(this)
  handleSubmit(ev) {
    ev.preventDefault();
    this.props.onSubmit({ token: this.state.value });
  }

  render() {
    const options = {
      expiration: 'never',
      scope: 'read,write,account',
      response_type: 'token',
      name: 'Trello Cards',
      key: TRELLO_KEY,
    };
    const url = `${AUTH_URL}?${serialize(options)}`;
    return (
      <Wrapper>
        <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="getToken">
            <HelpBlock><a href={url} target="_blank">Get a Trello Token</a></HelpBlock>
            <ControlLabel>Trello Token:</ControlLabel>
            <FormControl
              type="text"
              value={this.state.value}
              required
              onChange={this.handleChange}
            />
          </FormGroup>
          <Button type="submit" bsStyle="primary" >Submit</Button>
        </form>
      </Wrapper>
    );
  }
}

GetToken.propTypes = {
  onSubmit: PropTypes.func,
};

export default GetToken;



// WEBPACK FOOTER //
// ./src/components/GetToken.js